import { makeStyles } from '@material-ui/core';

export const useStyles = makeStyles((theme) => ({
  container: {
    display: 'flex',
    flexWrap: 'wrap',
    [theme.breakpoints.down(theme.size.sm)]: {
      flexDirection: 'column-reverse',
    },
  },
  borderedBox: {
    width: '100%',
    marginBottom: 35,
    padding: 25,
    borderLeftWidth: 13,
    boxShadow: '0 5px 8px #7088d234',
    '&:last-child': {
      marginBottom: 0,
    },
    [theme.breakpoints.down('sm')]: {
      padding: 15,
      borderLeftWidth: 8,
      '&:first-child': {
        marginBottom: 0,
      },
      '&:last-child': {
        marginBottom: 35,
      },
    },
  },
  leftBox: {
    flex: 1,
    marginRight: 40,
    [theme.breakpoints.down('sm')]: {
      marginRight: 20,
    },
    [theme.breakpoints.down(theme.size.sm)]: {
      display: 'flex',
      flexDirection: 'column-reverse',
      marginRight: 0,
    },
  },
  rightBox: {
    display: 'flex',
    flex: 2,
    [theme.breakpoints.down(theme.size.sm)]: {
      marginBottom: 20,
    },
  },
  boxTitle: {
    margin: 0,
    marginBottom: '15px',
    fontSize: '16px',
    fontWeight: 400,
    color: theme.custom.darkBlue,
  },
  divider: {
    width: '100%',
    height: 1,
    background: '#707070',
  },
  month: {
    fontSize: 14,
    color: '#6e6e6e',
    textTransform: 'capitalize',
  },
  amount: {
    fontSize: 16,
    fontWeight: 700,
    color: theme.custom.darkBlue,
    textAlign: 'right',
  },
  monthsList: {
    margin: 0,
    marginBottom: 30,
    padding: 0,
    listStyle: 'none',
    '& li': {
      marginBottom: 10,
      '&:last-child': {
        marginBottom: 0,
      },
    },
  },
  monthsListItem: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    marginBottom: 10,
    '&:last-child': {
      marginBottom: 0,
    },
  },
  greyText: {
    fontSize: 14,
    color: '#6E6E6E',
  },
  dividedBlock: {
    display: 'flex',
    alignItems: 'center',
  },
  dividedBlockItem: {
    display: 'flex',
    flexDirection: 'column',
    width: 'auto',
    fontSize: 16,
    color: theme.custom.darkBlue,
    '&:first-child': {
      display: 'inline-flex',
      minWidth: 125,
      marginRight: 30,
    },
  },
  dividedBlockError: {
    margin: '3px 0',
    fontSize: 22,
  },
  numerator: {
    fontWeight: 700,
    textAlign: 'right',
  },
  denominator: {
    fontWeight: 700,
    textAlign: 'right',
  },
  percentage: {
    fontSize: 22,
    fontWeight: 700,
    textAlign: 'center',
  },
  ledgerAccounts: {
    margin: 0,
    padding: 0,
    listStyle: 'none',
  },
  ledgerAccount: {
    display: 'flex',
    flexWrap: 'wrap',
    justifyContent: 'space-between',
    marginBottom: 5,
    '&:last-child': {
      marginBottom: 0,
    },
  },
  ledgerAccountText: {
    marginRight: 7,
    fontSize: 14,
    color: '#6e6e6e',
    '&:nth-child(2)': {
      flex: 1,
    },
    '&:last-child': {
      marginRight: 0,
    },
  },
  topBar: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    marginBottom: 20,
    marginTop: 20,
  },
  controlBtns: {
    display: 'flex',
  },
  btn: {
    minWidth: 'auto',
    marginRight: 10,
    padding: 3,
    borderRadius: '50%',
    '&:last-child': {
      marginRight: 0,
    },
  },
  icon: {
    color: theme.custom.darkBlue,
  },
  title: {
    marginTop: 0,
    fontSize: 20,
    fontWeight: 700,
    color: theme.custom.darkBlue,
    [theme.breakpoints.down(theme.size.sm)]: {
      fontSize: 18,
    },
  },
}));
